import { apiRequest } from './api'
import {
  SharedMapAccess,
  CreateShareLinkRequest,
  ShareMapDirectRequest,
  ShareLinkResponse,
} from '../types/share'

export const shareService = {
  async createShareLink(
    request: CreateShareLinkRequest,
  ): Promise<ShareLinkResponse> {
    return apiRequest<ShareLinkResponse>('/share/link', {
      method: 'POST',
      body: JSON.stringify(request),
    })
  },

  async acceptShareLink(token: string): Promise<SharedMapAccess> {
    return apiRequest<SharedMapAccess>(`/share/accept/${token}`, {
      method: 'POST',
    })
  },

  async shareMapDirectly(
    request: ShareMapDirectRequest,
  ): Promise<SharedMapAccess> {
    return apiRequest<SharedMapAccess>('/share/direct', {
      method: 'POST',
      body: JSON.stringify(request),
    })
  },

  async getSharedMaps(): Promise<SharedMapAccess[]> {
    return apiRequest<SharedMapAccess[]>('/share/with-me')
  },

  async getMapShares(mapId: string): Promise<SharedMapAccess[]> {
    return apiRequest<SharedMapAccess[]>(`/share/map/${mapId}/users`)
  },

  async revokeShare(mapId: string, userId: string): Promise<void> {
    await apiRequest('/share/revoke', {
      method: 'DELETE',
      body: JSON.stringify({ mapId, userId }),
    })
  },

  async getShareLinkInfo(token: string): Promise<{
    mapName?: string
    mapDescription?: string
    permissions: string[]
    expiresAt?: Date
    remainingUses?: number | null
  }> {
    const response = await fetch(
      `${
        process.env.REACT_APP_API_URL || 'http://localhost:3001/api'
      }/share/link/${token}/info`,
    )

    const data = await response.json()

    if (!response.ok) {
      throw new Error(data.error || 'Failed to get share link info')
    }

    return data.data
  },
}
